import theme from '@gaia/theme';
import SidebarLoading from '@map/sidebars/SidebarLoading';

import {Sidebar, SidebarBody} from './Sidebar';

export default function FallbackSidebar() {
    return (
        <Sidebar>
            <SidebarBody>
                <div
                    style={{
                        height: `calc(100% - ${theme.spacing(6)})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <SidebarLoading />
                </div>
            </SidebarBody>
        </Sidebar>
    );
}
